import { render } from "./RangeMarker.vue?vue&type=template&id=0c0a518e&scoped=true"
import script from "./RangeMarker.vue?vue&type=script&lang=js"
export * from "./RangeMarker.vue?vue&type=script&lang=js"

import "./RangeMarker.vue?vue&type=style&index=0&id=0c0a518e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0a518e"]])

export default __exports__